var metafieldData = document.getElementById('metafield-container').getAttribute('data-metafield');
var metafieldData_max = document.getElementById('metafield-container-max').getAttribute('data-metafield-max');
const Bundles = {
    async onLoad() {
        this._init();
        this.slots = [];
    },

    async fetchVariantData() {
        const response = await fetch('https://api.skio.com/storefront-http/get-dynamic-box', {
            method: 'POST',
            headers: {
                "Content-Type": "application/json"
            },
            body: JSON.stringify({
                "productPlatformId": metafieldData
            }),
        });
        return response.json();
    },

    _productItem(product) {
        const $template = $('.bundles__product').first().clone();
        $template.find('.bundles__product-img').attr('src', product.imageSrc).attr('alt', product.productTitle);
        $template.find('.bundles__product-title').text(product.productTitle);
        $template.find('.bundles__product-vendor').text(product.vendor);

        if (product.background) {
            $template.css('background-color', product.background);
        }

        if (product.backgroundImage) {
            $template.css('background-image', product.backgroundImage);
        }

        return $template;
    },

    _renderSlots() {
        const slots = $(this.container).find('.bundles__slots');

        slots.find('.bundles__slot').each(function () {
        })
    },

    _renderProducts(products) {
        products.forEach((productItem) => {
            const foundObject = window.allProducts.find(obj => obj.handle === productItem.productHandle);

            const productData = {
                productTitle: productItem.productTitle,
                handle: productItem.productHandle,
                imageSrc: productItem.productImageSrc,
                productVariant: productItem.productVariants[0].platformId
            }

            if (foundObject) {
                Object.assign(productData, foundObject);
                const productEl = this._productItem(productData);
                this.productsGrid.append(productEl);
            }
        })
    },

    _switchSize(variant) {
        this.maxBoxAmount = +variant.data('size');

        document.dispatchEvent(new CustomEvent("variantChanged", {
            detail: {
                variantId: variant.val()
            }
        }));
    },

    _isSlotAvailable() {
        return (this.slots.length + 1) <= this.maxBoxAmount;
    },

    _UIState() {
        if (this.slots.length >= this.DynamicBox.sizeRange[0]) {
            $(".js-add-bundles-to-cart").attr('disabled', false);

        } else {
            $(".js-add-bundles-to-cart").attr('disabled', true);
        }

        if (this.slots.length == this.maxQty) {
            console.log(this.slots.length, 'this.slots.length');
            console.log(this.maxQty, 'this.maxQty');
            $(".bundles__slots-wrap").addClass('state-active');
        } else if (this.slots.length === 0) {
            $(".bundles__slots-wrap").removeClass('state-active');
        }
    },

    _resetAll() {
        $('.quantity-picker__inp').each(function () {
            $(this).val(0);
        })
        this.slots = [];
        this._renderSlots();
    },

    _slotsChecker() {
        if (this.slots.length > this.maxBoxAmount) {
            this._resetAll();
        }
    },

    _updateProgressBar() {
        if (!this.slots || !this.slots.length && !this.maxQty) return;
        const stripeInner = $(".bundles__thresholds-stripe-inner");
        const step = (100 / this.maxQty).toFixed(2);

        const amountInPercent = this.slots.length * step;

        $(".bundles__thresholds").find('.bundles__threshold').each((index, item) => {
            const currentItem = $(item);
            const currentQty = currentItem.data('threshold-qty');

            if (currentQty) {
                if (currentQty <= this.slots.length) {
                    currentItem.find('.bundles__threshold-amount').addClass('state-active');
                } else {
                    currentItem.find('.bundles__threshold-amount').removeClass('state-active');
                }
            }
        })

        if (amountInPercent <= 101) {
            stripeInner.css('width', `${amountInPercent}%`);
        }

        this._UIState();
        this._updatePrice();

    },

    _removeSlot(slot) {
        const target = slot.find('[data-platform-id]');
        const id = target.data('platform-id');
        const indexToDelete = this.slots.findIndex(obj => obj.productPlatformId == id);
        if (indexToDelete !== -1) {
            this.slots.splice(indexToDelete, 1);
            slot.html('');
            slot.css('background', 'none');
            slot.addClass('state-empty');

            this._updateProgressBar();
            this._updateSlots();
        }
    },

    _updateSlots() {
        if (!this.slots || !this.slots.length) return;
        const slotsEl = $('.bundles__slots');

        slotsEl.find('.bundles__slot').html('').css('background', 'none').addClass('state-empty');

        this.slots.forEach((item, index) => {
            const targetSlotItem =  slotsEl.find('.bundles__slot').eq(index);
            const $template = $('.bundles__slot--template').first().clone();

            if (targetSlotItem) {
                targetSlotItem.removeClass('state-empty');
                targetSlotItem.html('');

                if (item.bg.includes('linear')) {
                    targetSlotItem.css('background-image', item.bg);
                } else {
                    targetSlotItem.css('background-color', item.bg);
                }
                $template.attr('data-platform-id', item.productPlatformId);
                $template.find('img').attr('src', item.productImageSrc);
                targetSlotItem.prepend($template);
            }
        })

        this._updateProgressBar();
    },

    _updateQty() {
        this.totals.attr('data-current', this.slots.length);
        this.totals.attr('data-total', this.maxBoxAmount);
    },

    _prepareItems(items) {
        const itemMap = {};
        items.forEach(item => {
            const key = item.productVariants[0].platformId;

            if (itemMap[key]) {
                itemMap[key].quantity += 1;
            } else {
                itemMap[key] = { ...item, quantity: 1 };
            }
        });

        return Object.values(itemMap)
    },

    _renderThresholds(thresholds) {
        if (!thresholds) return;
        const bundleThresholdsContainer = $('.bundles__thresholds-inner');

        for (let key in thresholds) {
            if (thresholds.hasOwnProperty(key)) {
                const step = (100 / this.maxQty).toFixed(2);

                const thresholdTemplate = `
                <figure class="bundles__threshold" data-threshold-qty="${key}">
                    <div class="bundles__threshold-amount">
                        <span data-original-price="${thresholds[key]}">-${thresholds[key]}%</span>
                    </div>
                </figure>`;

                const $thresholdElement = $(thresholdTemplate);
                $thresholdElement.css('left', `${step * key}%`);

                bundleThresholdsContainer.append($thresholdElement);
            }
        }

        bundleThresholdsContainer.append('<div class="bundles__threshold bundles__threshold--hidden"></div>');
    },

    _updateThresholds() {
        const thresholds = $('.bundles__thresholds-inner').find('.bundles__threshold');

        thresholds.each((index, item) => {
            const currentItem = $(item);
            const currentAmountEl = currentItem.find('.bundles__threshold-amount span');
            const currentAmount = parseInt(currentAmountEl.data('original-price'));

            if (this.sellingFlow == 'subscription') {
                currentAmountEl.text(`-${currentAmount + this.saleSubscriptionPercent}%`);
            } else  {
                currentAmountEl.text(`-${currentAmount}%`);
            }
        })

        this._updatePrice();
    },

    _renderSellingPlans() {
        console.log(this.sellingPlans, 'selling plans is here');
        if (!this.sellingPlans) return;

        this.sellingPlans = this.sellingPlans.sort((a, b) => a.intervalCount - b.intervalCount);

        const targetSwitchersEl = $(".bundles__plans");
        let counter = 0;

        this.sellingPlans.forEach(plan => {
            const currentPlan = plan.planId.split('/');
            const currentPlanId = parseInt(currentPlan[currentPlan.length - 1]);

            const switcherItemTemplate = `<label class="bundles__switcher-item"><input type="radio" ${counter == 0 ? 'checked' : ''} value="subscription" data-plan-id="${currentPlanId}" name="subscription-plan"><div class="bundles__switcher-item-label">${plan.title}</div></label>`;

            const switcherItemEl = $(switcherItemTemplate);

            targetSwitchersEl.append(switcherItemEl);
            counter++;
        })

    },

    _returnRelatedSkioItem(id) {
        if (this.DynamicBox.selectableProductVariants && this.DynamicBox.selectableProductVariants.length) {
            const skioProduct = this.DynamicBox.selectableProductVariants.find(item => {
                const platformId = item.productPlatformId.split('/');
                const currentId = parseInt(platformId[platformId.length - 1]);

                return currentId === id;
            });

            return skioProduct;
        }
    },

    _addSlot(id, bg) {
        const slotObj = this._returnRelatedSkioItem(id);
        slotObj.bg = '';
        if ((this.slots.length + 1) <= this.maxQty) {
            if (slotObj && bg) {
                slotObj.bg = bg;
                slotObj.id = id;
                this.slots.push(slotObj);
                this._updateSlots();
            }
        }
        // console.log(this.slots.length);
    },

    _updatePrice() {
        const priceEl = $("#bundle-price");
        let totalOriginalPrice = this.slots.reduce((accumulator, currentObject) => {
            return accumulator + currentObject.productVariants[0].price;
        }, 0);
        const relatedDiscountPercent = this.DynamicBox.percentDiscountTier[this.slots.length] ? parseInt(this.DynamicBox.percentDiscountTier[this.slots.length]) : false;
        let priceWithDiscount = totalOriginalPrice * (1 -relatedDiscountPercent / 100);

        if (this.sellingFlow === 'subscription') {
            priceWithDiscount = totalOriginalPrice * (1 - (relatedDiscountPercent + this.saleSubscriptionPercent) / 100);
        }

        if (relatedDiscountPercent) {
            priceEl.text(`$${parseFloat(priceWithDiscount).toFixed(2)}`)
            priceEl.attr('data-original-price', `$${parseFloat(totalOriginalPrice).toFixed(2)}`);
        } else {
            priceEl.text(`$${totalOriginalPrice}`)
            priceEl.attr('data-original-price', ``);
        }


        // console.log(totalOriginalPrice, relatedDiscountPercent);
        // this.slots.length >= this.DynamicBox.percentDiscountTier
    },

    _filterItemsBySellingPlans() {

            if (this.sellingPlans) {
                this.productsGrid.find('.product-block').hide();

                this.sellingPlans.forEach((plan) => {
                    const variants = plan.variantMapping;
                    const currentPlan = plan.planId.split('/');
                    const currentPlanId = parseInt(currentPlan[currentPlan.length - 1]);

                    if (currentPlanId == this.currentSellingPlanId) {
                        this.saleSubscriptionPercent = plan.priceAdjustmentAmount;

                        for (const variantKey in variants) {
                            if (variants.hasOwnProperty(variantKey)) {
                                const targetVariantId = variantKey.split('/');
                                const variantId = parseInt(targetVariantId[targetVariantId.length - 1], 10);

                                this.productsGrid.find(`.product-block[data-variant-id="${variantId}"]`).show();

                            }
                        }
                    }
                })

                this._updateThresholds();
            }
    },

    async _init() {
        this.productsGrid = $(".bundles__parts");
        const skioResponse = await this.fetchVariantData();
        this.maxQty = metafieldData_max;

        if (skioResponse.ok) {
            this.DynamicBox = skioResponse.DynamicBox;
            this.sellingPlans = Object.entries(this.DynamicBox.sellingPlanGroup).map(([key, value]) => ({
                planId: key,
                ...value
              }));
            
            this._renderSellingPlans();
            this._renderThresholds(this.DynamicBox.percentDiscountTier);
            this.saleSubscriptionPercent = this.sellingPlans[0].priceAdjustmentAmount;

            // this._renderProducts(this.DynamicBox.selectableProductVariants)
        }

        $(".js-add-to-bundle, .product-link").on('click', (e) => {
            e.preventDefault();

            const currentBtn = $(e.target);
            const currentCard = currentBtn.closest('.product-block');
            const currentBg = currentCard.css('background').includes('linear') ? currentCard.css('background-image') : currentCard.css('background-color');

            this._addSlot(currentCard.data('product-id'), currentBg);
        })

        $(".bundles__select").on('change', function (e) {
            e.preventDefault();
            const currentBtn = $(this);
            const targetContent = $(currentBtn).closest('.bundles').find(".bundles__parts");

            targetContent.find('.bundles__part').hide();
            targetContent.find(`${currentBtn.val()}`).fadeIn();
        })

        $(".bundles__nav").on('click', "a", function (e) {
            e.preventDefault();
            const currentBtn = $(this);
            const currentVal = currentBtn.attr('href');
            const targetContent = $(currentBtn).closest('.bundles').find(".bundles__parts");

            currentBtn.closest('ul').find('a.active').removeClass('active');
            currentBtn.addClass('active');

            if (currentVal.includes('all')) {
                targetContent.find('.bundles__part').fadeIn();
            } else {
                targetContent.find('.bundles__part').hide();
                targetContent.find(`${currentBtn.attr('href')}`).fadeIn();
            }
        })

        $(".bundles__slot").on('click', (e) => {
            const currentSlot = $(e.target);
            this._removeSlot(currentSlot);
        })

        $(".bundles__main-header").on('click', function (e) {
            e.preventDefault();
            const currentBtn = $(this);
            currentBtn.toggleClass('state-active');
            $(".bundles__slots-wrap").toggleClass('state-active');
        })

        $('[name="subscription-plan"]').on('change', (e) => {
            this.currentSellingPlan = $(e.target).val();
            this.currentSellingPlanId = $(e.target).data('plan-id');
            this._filterItemsBySellingPlans(this.currentSellingPlan);
        })

        if ($('[name="subscription-plan"]:checked').length) {
            const sellingPlanId = $('[name="subscription-plan"]:checked').data('plan-id');
            this.currentSellingPlanId = sellingPlanId;
        }

        $('[name="selling-plan"]').on('change', (e) => {
            this.sellingFlow = $(e.target).val();
            this._updateThresholds();

            if (this.sellingFlow === 'subscription') {
                $(".bundles__plans").addClass('state-active')
            } else {
                $(".bundles__plans").removeClass('state-active')
            }
        })

        $('.js-add-bundles-to-cart').on('click', (e)=> {
            const sellingPlanId = this.sellingFlow === 'subscription' ? this.currentSellingPlanId : '';

            const items = [
                // {
                //     ...(sellingPlanId && { selling_plan: sellingPlanId }),
                //     properties: {}
                // }
            ];

            const preparedItems = this._prepareItems(this.slots);

            if (!preparedItems.length) return;

            preparedItems.forEach((box, index) => {
                const parts = box.productVariants[0].platformId.split('/');
                const activeVariantId = parts[parts.length - 1];
                const obj = {
                    // selling_plan: 21184512036,
                    selling_plan: sellingPlanId,
                    properties: {}
                }

                obj.id = activeVariantId;
                obj.quantity = box.quantity;
                obj.properties['_dynamicBoxIndex'] = 0;
                obj.properties['_dynamicBoxId'] = this.DynamicBox.boxId;
                
                items.push(obj);
            })
            // console.log(items, preparedItems);

            const baseUrl = `${Shopify.routes.root}cart/clear?return_to=/cart/add?`;
            const returnPath = "%26return_to=/checkout";

            let itemParams = '';
            console.log(items);

            items.forEach((item, index) => {
                itemParams += `%26items[${index}][quantity]=${item.quantity}%26items[${index}][selling_plan]=${item.selling_plan}%26items[${index}][id]=${item.id}%26items[${index}][properties][_dynamicBoxId]=${item.properties._dynamicBoxId}%26items[${index}][properties][_dynamicBoxIndex]=0`;
            })


            const magicLink = `${baseUrl}${itemParams}${returnPath}`;

            console.log(magicLink);

            window.location.href = magicLink;

            // fetch('/cart/add.js', {
            //     method: 'POST',
            //     headers: {
            //         'Content-Type': 'application/json'
            //     },
            //     body: JSON.stringify({ items })
            // })
            //     .then(response => response.json())
            //     .then(response => {
            //         console.log(response);
            //         // console.log(`SKIO added item to cart: ${response.items[0].product_title} x ${quantity}`);
            //     })
            //     .catch(error => {
            //         console.error("SKIO error adding item to cart: ", error);
            //     });
        });

    },
};

export default Bundles;